export default {"src":"/_next/static/media/checkmark_circle.ba3ad5e6.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};